


import React, { createContext, useEffect, useReducer } from "react";
import Reducer from "./Reducer";

const initialState = { lang: "ka" };

const Products = ({ children }) => {
    const [state, dispatch] = useReducer(Reducer, initialState);

    useEffect(() => {
        document.documentElement.lang = state.lang;
    }, [state.lang]);

    return (
        <Context.Provider value={[state, dispatch]}>
            <div className={`web-${state.lang}`}>
                {children}
            </div>
        </Context.Provider>
    )
};

export const Context = createContext({ lang: "ka" });

export default Products;
